var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgExcel = function SvgExcel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#08A54A",
    d: "M2.25 0A2.26 2.26 0 0 0 0 2.25v15.5A2.26 2.26 0 0 0 2.25 20h11.5A2.26 2.26 0 0 0 16 17.75V7.25a.75.75 0 0 0-.22-.53l-.007-.008L9.28.22A.75.75 0 0 0 8.75 0zm0 1.5H8v4.25A2.26 2.26 0 0 0 10.25 8h4.25v9.75c0 .423-.327.75-.75.75H2.25a.74.74 0 0 1-.75-.75V2.25c0-.423.327-.75.75-.75M9.5 2.56l3.94 3.94h-3.19a.74.74 0 0 1-.75-.75zM6.27 9.5a.75.75 0 0 0-.653 1.152L7.111 13l-1.494 2.348a.75.75 0 0 0 1.266.805L8 14.398l1.117 1.754a.75.75 0 0 0 1.035.23.75.75 0 0 0 .23-1.035L8.89 13l1.493-2.347a.75.75 0 1 0-1.266-.806L8 11.603 6.883 9.848A.75.75 0 0 0 6.27 9.5"
  })));
};
export default SvgExcel;